import React from "react";
import RateMatrix from "./RateMatrix";

const CashRate = ({
  rateMatrixData = () => {},
  quotationRateMatrix,
  type,
  actionEdit,
}) => {
  return (
    <div>
      <RateMatrix
        rateMatrixData={rateMatrixData}
        quotationRateMatrix={quotationRateMatrix}
        type={type}
        actionEdit={actionEdit}
      />
    </div>
  );
};
export default CashRate;
